/**
 * QR code and session code overlay for joining.
 *
 * Fills the height it is given: the QR is a square inscribed in the space left
 * after the texts, bounded by both the column width and the remaining height.
 *
 * The QR itself is the decorated StyledQrCode (qr-code-styling).
 */

import { useTranslation } from 'react-i18next'
import { SessionCode } from '@/components/low/SessionCode'
import { StyledQrCode } from './StyledQrCode'

interface JoinOverlayProps {
  code: string
}

export function JoinOverlay({ code }: JoinOverlayProps) {
  const { t } = useTranslation()
  const joinUrl = `${window.location.origin}/join/${code}`

  return (
    <div className="h-full flex flex-col items-center gap-2 animate-in fade-in zoom-in duration-700">
      <div className="flex-1 min-h-0 w-full flex items-center justify-center [container-type:size]">
        <div className="aspect-square w-[min(100cqw,100cqh)] bg-white rounded-[1.5rem] overflow-hidden shadow-[0_0_50px_color-mix(in_srgb,var(--primary)_30%,transparent)]">
          <StyledQrCode value={joinUrl} />
        </div>
      </div>

      <div className="text-center space-y-1">
        <p className="text-muted-foreground uppercase tracking-[0.3em] text-sm font-black whitespace-nowrap">{t('join.scanToJoin')}</p>
        <SessionCode code={code} size="lg" className="text-foreground text-3xl tracking-[0.15em] whitespace-nowrap" />
        <p className="text-primary/60 text-lg font-medium">game.giermek.online/join</p>
      </div>
    </div>
  )
}
